import styled from "styled-components"
import {rgba} from "polished"

import {Card} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"

interface StyledProps {
  c1: string
  c2: string
}

export const LinearGradiantCard = styled(Card)<StyledProps>`
  flex: 1 1 0;
  background-image: ${({c1, c2}) => `linear-gradient(to right, ${c1}, ${c2})`};
`

export const NumberOfRedemptions = styled(Flex)`
  min-width: 115px;
  min-height: 115px;
  border-radius: 100%;
  border: 8px solid ${({theme}) => `${rgba(theme.colors.greys.white, 0.8)}`};
  background: ${({theme}) => theme.colors.primary1};
  overflow: hidden;
`
